module.exports = __webpack_public_path__ + "img/PlayersTrust_V_LBG_RGB.7188b8ee.png";